import React from 'react';
import { motion } from 'framer-motion';
export function AboutCTA() {
  return <section className="bg-white py-24 md:py-32 px-6" data-id="element-4">
      <div className="max-w-4xl mx-auto text-center" data-id="element-5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-6">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-7">
            Get Involved
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6" data-id="element-8">
            Join Our Journey
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-9" />
          <p className="text-[#86868b] text-[18px] md:text-[20px] leading-relaxed mb-12 font-light" data-id="element-10">
            Whether you're looking to dine at one of our restaurants, partner
            with us, or join our team, we'd love to hear from you. Discover the
            BV Group Hospitality experience today.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center" data-id="element-11">
            <a href="#contact" className="inline-flex items-center px-10 py-4 bg-[#c9a961] text-black font-medium text-[14px] uppercase tracking-wide rounded-sm hover:bg-[#d4b872] transition-all duration-300 min-w-[200px] justify-center" data-id="element-12">
              Contact Us
            </a>
            <a href="#businesses" className="inline-flex items-center px-10 py-4 text-[#1d1d1f] font-medium text-[14px] uppercase tracking-wide rounded-sm border border-[#1d1d1f]/20 hover:border-[#c9a961] hover:text-[#c9a961] transition-all duration-300 min-w-[200px] justify-center" data-id="element-13">
              Explore Portfolio
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}